import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import {Grid, Typography, useMediaQuery} from "@material-ui/core";
import Logo from '../../assests/images/logo.svg'
import Youtube from '../../assests/images/youtube.svg'
import Instagram from '../../assests/images/instagram.svg'
import Facebook from '../../assests/images/facebook.svg'
import Twitter from '../../assests/images/twitter.svg'
import Powered from '../../assests/images/powered.svg'
import {useContext} from "react";
import {JsonContext} from "../../Context";
import YouTubeIcon from '@material-ui/icons/YouTube';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import {Link} from "react-router-dom";


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: '0 72px',
    color: '#fff',
    [theme.breakpoints.down('sm')]: {
        padding: '0 48px'
    },
    [theme.breakpoints.down('xs')]: {
        padding: '0 15px'
    },
  },
  imageWrapper: {
      padding: '40.5px 0',
      justifyContent: 'space-between',
      alignItems: 'center',
      [theme.breakpoints.down('xs')]: {
        padding: '20px 0'
    },
  },
  listWrapper: {
    listStyle: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '20px 0',
    padding: '0',
    [theme.breakpoints.down('xs')]: {
        display: 'block'
    },
  },
  list: {
      fontFamily: 'Roboto',
      fontSize: '14px',
      lineHeight: '24px',
      letterSpacing: '0.11px',
      [theme.breakpoints.down('xs')]: {
        width: '49%',
        display: 'inline-block'
    },
  },
  listItem: {
    color: theme.palette.text.primary,
    opacity: '0.7',
    textDecoration: 'none',
    textTransform: 'uppercase'
  },
  follow: {
    textAlign:'right',
    fontFamily: 'Roboto',
    fontSize: '16px',
    lineHeight: '24px',
    letterSpacing: '0.11px',
    fontWeight: '600',
    textTransform: 'uppercase',
    margin: '0',
    [theme.breakpoints.down('md')]: {
      textAlign: 'right',
      margin: '0 0 8px'
  },
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        margin: '0 0 8px'
    },
  },
  socialLinks: {
      margin: '5px 5px 0 0',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: theme.palette.border.primary,
      borderRadius: '100px',
      width: '48px',
      height: '48px',
      // [theme.breakpoints.down('md')]: {
      //   textAlign: 'left',
      // },
      '&:hover': {
        background: theme.palette.background.hover,
      }
  },
  acknowledge: {
      fontSize: '12px',
      lineHeight: '16px',
      fontFamily: 'Manrope',
      fontWeight: '700',
      margin: '0 0 8px',
      opacity: '0.7',
      width: '100%',
      textAlign: 'center'
  },
  people: {
    fontSize: '12px',
    lineHeight: '16px',
    fontFamily: 'Manrope',
    opacity: '0.7',
    textAlign: 'center',
    width: '890px',
    [theme.breakpoints.down('xs')]: {
        width: '100%'
    },
  },
  divider: {
      height: '2px',
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      opacity: 0.7,
      margin: '32px 0',
      [theme.breakpoints.down('xs')]: {
        margin: '24px 0',
    },
  },
  rights: {
    fontSize: '12px',
    lineHeight: '16px',
    fontFamily: 'Manrope',
    opacity: '0.7',
    margin: '0 0 5px',
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
    },
  },
  listReservedWrapper: {
      listStyle: 'none',
      margin: '0 0 32px',
      padding: '0',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        margin: '0 0 20px',
    },
  },
  listReserved: {
    fontSize: '12px',
    lineHeight: '16px',
    fontFamily: 'Manrope',
    display: 'inline-block',
    margin: '0 12px 0 0'
  },
  listReservedItem: {
    color: theme.palette.text.primary, 
    opacity: '0.7',
    textDecoration: 'underline'
  },
  powered: {
    textAlign: 'right',
    fontSize: '12px',
    lineHeight: '16px',
    fontFamily: 'Manrope',
    opacity: '0.7',
    margin: '0 0 5px',
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
    },
  },
  listPolicyWrapper: {
    listStyle: 'none',
    margin: '0 0 32px',
    padding: '0',
    textAlign: 'right',
    [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        margin: '0 0 20px',
    },
  },
  sponsorImage: {
      textAlign: 'center'
  },
  mainWrapper: {
    [theme.breakpoints.down('xs')]: {
        textAlign: 'center',
    },
  },
  mobileWrapper: {
    [theme.breakpoints.down('md')]: {
      paddingTop: '30px',
      textAlign: 'left'
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    },
  },
  socialLinksWrapper: {
    [theme.breakpoints.down('md')]: {
      textAlign: 'right'
    },
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center'
    },
  },
  mobileImg: {
      marginBottom: '24px'
  },
  topContainer: {
      paddingTop: '44px'
  },
  iconBtn: {
    fill: theme.palette.fill.color,
  },
  mediaWrapper: {
    display: 'flex',
    justifyContent: 'center'
  }
}));


export default () => {
  const classes = useStyles();
  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("md"));
  const data = useContext(JsonContext).footer;

    return (
    <div className={classes.root}>
      {!isSmallScreen ? <Grid container className={classes.topContainer}>
           <Grid md={3} xs={12}>
               <Link to={'/'}><img src={data.logo||Logo} alt="Museum" /></Link>
            </Grid> 
            <Grid md={6} xs={12}>
               <ul className={classes.listWrapper}>
                   <li className={classes.list}>
                       <a href={data.otherLinks.latestNews} target={'_blank'} className={classes.listItem}>Latest News</a>
                   </li>
                   <li className={classes.list}>
                       <a href={data.otherLinks.about} target={'_blank'} className={classes.listItem}>About</a>
                   </li>
                   <li className={classes.list}>
                       <a href={data.otherLinks.media} target={'_blank'} className={classes.listItem}>Media</a>
                   </li>
                   <li className={classes.list}>
                       <a href={data.otherLinks.faqs} target={'_blank'} className={classes.listItem}>Faqs</a>
                   </li>
               </ul>
            </Grid> 
            <Grid md={3} xs={12}>
               <Typography component={'h4'} variant={'body1'} className={classes.follow}>
               Follow Us
               </Typography>
               <Grid style={{float: 'right', display: 'flex'}}>
                <a href={data.socialLinks.youtube} target={'_blank'} className={classes.socialLinks}><YouTubeIcon className={classes.iconBtn} /></a>
                <a href={data.socialLinks.instagram} target={'_blank'} className={classes.socialLinks}><InstagramIcon className={classes.iconBtn} /></a>
                <a href={data.socialLinks.facebook} target={'_blank'} className={classes.socialLinks}><FacebookIcon className={classes.iconBtn} /></a>
                <a href={data.socialLinks.twitter} target={'_blank'} className={classes.socialLinks} style={{margin: '5px 0'}}><TwitterIcon className={classes.iconBtn} /></a>
               </Grid>
            </Grid> 
      </Grid> :
      <Grid container className={classes.mobileWrapper}>
           <Grid md={6} xs={12}>
               <img src={Logo} alt="Museum" className={classes.mobileImg} />
            </Grid> 
            <Grid md={6} xs={12} className={classes.socialLinksWrapper}>
               <Typography component={'h4'} variant={'body1'} className={classes.follow}>
               Follow Us
               </Typography>
               <Grid className={classes.mediaWrapper}>
                   <a href={data.socialLinks.youtube} target={'_blank'} className={classes.socialLinks}><YouTubeIcon className={classes.iconBtn} /></a>
                   <a href={data.socialLinks.instagram} target={'_blank'} className={classes.socialLinks}><InstagramIcon className={classes.iconBtn} /></a>
                   <a href={data.socialLinks.facebook} target={'_blank'} className={classes.socialLinks}><FacebookIcon className={classes.iconBtn} /></a>
                   <a href={data.socialLinks.twitter} target={'_blank'} className={classes.socialLinks} style={{margin: '5px 0'}}><TwitterIcon className={classes.iconBtn} /></a>
               </Grid>
            </Grid> 
            <Grid md={12} xs={12}>
               <ul className={classes.listWrapper}>
                   <li className={classes.list}>
                       <a href={data.otherLinks.latestNews} target={'_blank'} className={classes.listItem}>Latest News</a>
                   </li>
                   <li className={classes.list}>
                       <a href={data.otherLinks.about} target={'_blank'} className={classes.listItem}>About</a>
                   </li>
                   <li className={classes.list}>
                       <a href={data.otherLinks.media} target={'_blank'} className={classes.listItem}>Media</a>
                   </li>
                   <li className={classes.list}>
                       <a href={data.otherLinks.faqs} target={'_blank'} className={classes.listItem}>Faqs</a>
                   </li>
               </ul>
            </Grid> 
            
      </Grid>}
      <Divider className={classes.divider} />
      <Grid container style={{justifyContent: 'center'}}>
         <Typography component={'h5'} variant={'body1'} className={classes.acknowledge}>
            Acknowledgement to Country
         </Typography>
         <Typography component={'p'} variant={'body1'} className={classes.people}>{data.acknowledgement}</Typography>
      </Grid>
      <Divider className={classes.divider} />
      <Grid container>
        <Grid md={6} xs={12}>
          <Typography component={'p'} variant={'body1'} className={classes.rights}>
            © 2022 World Science Festival Brisbane. All Rights Reserved
           </Typography>
            <ul className={classes.listReservedWrapper}>
                <li className={classes.listReserved}>
                    <a href={data.disclaimer} target={'_blank'} className={classes.listReservedItem}>Disclaimer</a>
                </li>
                <li className={classes.listReserved}>
                    <a href={data.privacy} target={'_blank'} className={classes.listReservedItem}>Privacy & Security</a>
                </li> 
                <li className={classes.listReserved}>
                    <a href={data.rightToInfo} target={'_blank'} className={classes.listReservedItem}>Right to Information</a>
                </li>
            </ul>
        </Grid>
        <Grid md={6} xs={12}>
           <Typography component={'p'} variant={'body1'} className={classes.powered}>
            <img src={Powered} alt="Powered" style={{marginRight: '5px', display: 'inline-block', verticalAlign: 'middle'}} />Event powered by Corrivium Live
            </Typography>
            <ul className={classes.listPolicyWrapper}>
                <li className={classes.listReserved}>
                    <a href={data.privacyPolicy} target={'_blank'} className={classes.listReservedItem}>Privacy Policy</a>
                </li>
                <li className={classes.listReserved}>
                    <a href={data.siteTerms} target={'_blank'} className={classes.listReservedItem}>Site terms</a>
                </li>
            </ul>
        </Grid>
      </Grid>
    </div>
  );
}

